import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import App from './App';
import './index.css';

const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element not found');
}

createRoot(root).render(
  <StrictMode>
    <HashRouter>
      <App />
      <Toaster
        position="top-right"
        toastOptions={{
          className: 'bg-[#151632] text-white border border-[#1E2048]',
          style: {
            background: '#151632',
            color: '#fff',
            border: '1px solid #1E2048',
          },
          success: {
            iconTheme: {
              primary: '#34D399',
              secondary: '#151632',
            },
          },
          error: {
            iconTheme: {
              primary: '#EF4444',
              secondary: '#151632',
            },
          },
        }}
      />
    </HashRouter>
  </StrictMode>
);